// ONE CORE lives on the public HTTPS backend. The website and the native
// Capacitor shell must never resolve /api against a local WebView origin.
export const ONE_CORE_PUBLIC_API = "https://omnisynia-backend-michel.onrender.com/api";

export interface ApiOriginContext {
  hostname: string;
  isNative: boolean;
  configuredBase?: string;
}

const officialHosts = new Set([
  "omnisynia.com",
  "www.omnisynia.com",
  "omnisynia-app-michel.onrender.com"
]);

export function resolveApiBaseUrl(context: ApiOriginContext): string {
  const hostname = context.hostname.toLowerCase();
  if (context.isNative || officialHosts.has(hostname)) {
    // Neither a relative Vite env override nor a stale custom build may
    // send the signed app's private session to a different origin.
    return ONE_CORE_PUBLIC_API;
  }
  return context.configuredBase?.trim() || "/api";
}
